module.exports = __webpack_public_path__ + "img/69.7be67610.png";